import { render } from "./activityManager.vue?vue&type=template&id=53f16c7b&scoped=true"
import script from "./activityManager.vue?vue&type=script&lang=js"
export * from "./activityManager.vue?vue&type=script&lang=js"

import "./activityManager.vue?vue&type=style&index=0&id=53f16c7b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f16c7b"]])

export default __exports__